/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {useIntl} from "react-intl";
import {AELink} from "../../../_emywork/components/AELink";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../Dashboard/_redux/actions";
import {AESVG} from "../../../_emywork/components/svg";

export function TeamsWidget({ }) {
  const {formatMessage} = useIntl()
  const dispatch = useDispatch()
  const teams = useSelector(({statistics})=>statistics.teams)

  useEffect(()=>{
    dispatch(actions.fetchTeamsStatistics())
  }, [])

  return (
    <>
      <div className={`card card-custom gutter-b`}>
        <div className="card-body">
          <AESVG
            size={'3x'}
            variant={`primary`}
            className={'ml-n2'}
            path={'/Communication/Group-chat.svg'}
          />

          <div className="text-dark font-weight-bolder font-size-h2 mt-3">
            {teams.total_my_teams}
          </div>
          <AELink
            to={"/teams"}
            className={"text-muted text-hover-primary font-weight-bold font-size-lg mt-1"}
            >
            {formatMessage({id: "TEAMS"})}
          </AELink>
        </div>
      </div>
    </>
  );
}
